import React from 'react';
import './StaticPage.css';

export const Terms = () => {
  return (
    <div className="static-page">
      <div className="static-page-card">
        <h1 className="static-page-title">Terms</h1>
        <div className="static-page-body">
          <p>
            By using our website, https://www.cinebotz.com/ , you agree to our use of cookies in accordance with this policy.
          </p>
          <p>
            Our website uses cookies to enhance your browsing experience and to better understand how you interact with our site. A cookie is a small text file that is stored on your device when you visit our website.
          </p>
          <p>
            We use cookies to remember your preferences, such as language and region, and to analyze traffic on our site. We also use cookies to show you personalized content and ads.
          </p>
          <p>
            You have the option to accept or decline cookies by modifying your browser settings. However, please note that declining cookies may limit your ability to use certain features on our site.
          </p>
          <p>
            We do not share or sell any personal information collected through cookies to third parties.
          </p>
          <p>
            We reserve the right to make changes to this policy at any time. Your continued use of our website following any changes indicates your acceptance of the new policy.
          </p>
          <p>
            If you have any questions or concerns about our use of cookies, please contact us at cinebotz@gmail.com
          </p>
        </div>
      </div>
    </div>
  );
};
